// extracted by mini-css-extract-plugin
module.exports = {"containerItem":"rules-matcher_containerItem__35zTe","text":"rules-matcher_text__3XMCo","active":"rules-matcher_active__3Pq6K","error":"rules-matcher_error__1YEwb"};